import React, { useMemo } from "react";
import { EChartsOption } from "echarts";
import ReactEchart from "../../../../../../molecules/ReactEchart";

const RecurrencePieChart: React.FC = () => {
  const chartData = useMemo(
    () => [
      { value: 6143, name: "New Issue", itemStyle: { color: "#2F6D94" } },
      { value: 40913, name: "Recurring Issue", itemStyle: { color: "#0E3D5D" } },
    ],
    []
  );

  const options: EChartsOption = useMemo(
    () => ({
      tooltip: {
        trigger: "item",
      },
      legend: {
        bottom: 0,
        left: "center",
        icon: "circle",
        itemGap: 40,
        textStyle: {
          fontSize: 14,
          rich: {
            dot: { fontSize: 18, fontWeight: "bold", verticalAlign: "middle" },
            name: { fontSize: 14, color: "#666", verticalAlign: "middle" },
            value: { fontWeight: "bold", fontSize: 18, color: "#1F5782", marginTop: 8 },
            percentage: { fontSize: 14, color: "#5A7D99" },
          },
        },
        formatter: (name: string) => {
          const item = chartData.find((d) => d.name === name);
          if (!item) return name;

          const total = chartData.reduce((sum, d) => sum + d.value, 0);
          const percentage = ((item.value / total) * 100).toFixed(2) + "%";

          return `{name|${name}}\n\n{value|${item.value}}   {percentage|(${percentage})}`;
        },
      },
      series: [
        {
          name: "Access From",
          type: "pie",
          radius: ["40%", "70%"],
          center: ["50%", "35%"],
          avoidLabelOverlap: false,
          label: { show: false, position: "center" },
          emphasis: { label: { show: false, fontSize: 40, fontWeight: "bold" } },
          labelLine: { show: false },
          data: chartData,
        },
      ],
    }),
    [chartData]
  );

  return <ReactEchart options={options} style={{ height: "400px", width: "100%" }} />;
};

export default RecurrencePieChart;
